import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import store, { CREATE_AUTH_TOKEN_ENDPOINT } from "@/store";
import localforage from "localforage";

@Module({ store, name: "authentication" })
export default class Authentification extends VuexModule {
  public authToken: string = "";

  protected _IDB_KEY_AUTH_TOKEN: string = "auth_token";

  public get IDB_KEY_AUTH_TOKEN(): string {
    return this._IDB_KEY_AUTH_TOKEN;
  }

  public get getAuthToken(): string {
    return this.authToken;
  }

  @Mutation
  public async setAuthToken(attrs: any) {
    this.authToken = attrs.auth_token;
    if (attrs.newToken) {
      const authToken = await localforage.setItem(this._IDB_KEY_AUTH_TOKEN, attrs.auth_token);
    }
    if (attrs.app) {
      attrs.app.handleLoginStatusMessage();
    }
  }

  @Action
  public async requestAuthToken(attrs: any) {
    const req = await fetch(CREATE_AUTH_TOKEN_ENDPOINT, {
      method: "POST",
      body: JSON.stringify({
        username: attrs.username,
        password: attrs.password
      })
    });
    const res = await req.json();
    if (res.status === "success") {
      this.context.commit("setAuthToken", { auth_token: res.auth_token, newToken: true, app: attrs.app });
    } else {
      attrs.app.handleLoginStatusMessage(res);
    }
  }

  @Action
  public async currentAuthToken() {
    const authToken = await localforage.getItem(this._IDB_KEY_AUTH_TOKEN);
    if (authToken) {
      this.context.commit("setAuthToken", { auth_token: authToken });
      return authToken;
    }
    return null;
  }
}
